export const ACTIVITY_KEY = "lastActivityAt";
export const DEFAULT_IDLE_LIMIT_MS = 60 * 60 * 1000; // 60 minutes
export const DEFAULT_WARN_BEFORE_MS = 2 * 60 * 1000; // final 2 minutesD

function resolveOverrideMs(key, fallback) {
    if (typeof window === "undefined") return fallback;
    const fromStorage = parseInt(window.localStorage.getItem(key) || "", 10);
    if (Number.isFinite(fromStorage) && fromStorage > 0) return fromStorage;
    const fromGlobal = parseInt(window[key], 10);
    if (Number.isFinite(fromGlobal) && fromGlobal > 0) return fromGlobal;
    return fallback;
}

export function getIdleLimitMs() {
    return resolveOverrideMs("__RDC_IDLE_LIMIT_MS__", DEFAULT_IDLE_LIMIT_MS);
}

export function getWarnBeforeMs() {
    return Math.max(
        0,
        Math.min(
            resolveOverrideMs("__RDC_WARN_BEFORE_MS__", DEFAULT_WARN_BEFORE_MS),
            getIdleLimitMs()
        )
    );
}
